import {
  ActionValidation,
  BooleanValidation,
  NumberValidation,
  ObjectValidation,
  StringValidation,
} from '../../../../utils/component-validations';
import { eq } from 'ember-truth-helpers';
import { fn, hash } from '@ember/helper';
import Menu from './menu/base.gjs';
import NoResults from '../../core/menu/no-results.gjs';
import SearchMenuItem from './menu/item.gjs';
import Super from '../../core/menu/parent.gjs';
import boldMatchingText from '../../../../modifiers/bold-matching-text';

const Item = <template>
  <SearchMenuItem
    @onClick={{@onClick}}
    @registerComponent={{@registerComponent}}
    @retainSelection={{@retainSelection}}
    @unregisterComponent={{@unregisterComponent}}
    @value={{@value}}
    {{boldMatchingText @searchValue}}
    ...attributes
  >
    {{yield}}
  </SearchMenuItem>
</template>;

export default class SpdsInputSearchMenu extends Super {
  arguments = [
    new ActionValidation({ required: ['onSelect'] }),
    new BooleanValidation({ required: ['open'] }),
    new NumberValidation({ required: ['displayedItemCount'] }),
    new ObjectValidation({ required: ['anchorElement'] }),
    new StringValidation({ optional: ['noResultsText'] }),
  ];
  baseClass = 'spds-input-search-menu';

  <template>
    <Menu
      @anchorElement={{@anchorElement}}
      @id={{@id}}
      @open={{@open}}
      @noItemsDisplayed={{eq @displayedItemCount 0}}
      @noResultsText={{@noResultsText}}
      class="spds-input-search-menu"
      data-test-spds-input-search-menu
      {{this.validateArguments}}
      ...attributes
    >
      {{yield
        (hash
          item=(component
            Item
            onClick=@onSelect
            registerComponent=(fn this.registerItem false)
            retainSelection=@retainSelection
            searchValue=@searchValue
            unregisterComponent=this.unregisterItem
          )
          noResults=(component NoResults)
        )
      }}
    </Menu>
  </template>
}
